class ticketedPointEditCtrl0 {
    constructor($rootScope, $scope, httpRequest, $state, formvalidateApi, logger, $uibModal) {
        // 初始化表单数据
        const _ukeyId = $state.params.ukeyId
        if (_ukeyId === 'undefined') {
            $state.go('system.basedata.ticketedPoint.list')
        }
        const userInfo = JSON.parse(localStorage.user_info)
        $scope.sale = userInfo.sale
        $scope.taxDiskForm0 = {
            accountId: '',
            bank: '',
            bankAccount: '',
            createTime: '',
            createUser: '',
            diskCode: '',
            diskId: 0,
            diskName: '',
            diskNo: '',
            diskType: '',
            electronicQuota: 0,
            generalQuota: 0,
            ipAddress: '',
            port: 0,
            remark: '',
            saleId: 0,
            specialQuota: 0,
            status: 1,
            tenantId: 0,
            ukeyNum: 0,
            updateTime: '',
            updateUser: '',
            ukeyCode: '',
            ukeyName: '',
            volumeQuota: 0,
            differentInvoice: 0,
            serverCode: '',
            eleSpecialQuota: '',
        }
        // 状态标志
        $scope.statusList = [
            {
                id: 0,
                text: '未启用',
            },
            {
                id: 1,
                text: '启用',
            },
        ]
        // 查询银行信息
        $scope.bankList = []
        const typecodeArrStr = '["manage_type","ovat_disk_type","platform_type"]'
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            // $scope.dictData = res.data.value['manage_type']
            $scope.dictData = res.data.value
            $scope.editDiskType = res.data.value['ovat_disk_type']
            // 获取信息
            httpRequest.get_getTaxDisk(_ukeyId).then((res) => {
                $scope.taxDiskForm0 = $.extend({}, $scope.taxDiskForm0, res.data.value)
                $scope.taxDiskForm0.diskType = '' + $scope.taxDiskForm0.diskType + ''
                // 放开
                // if($scope.taxDiskForm0.manageType!=2){
                //     $scope.dictData = $scope.dictData.filter(({ enumCode }) => enumCode != 2);
                // }
                httpRequest.post_getEnableBankOfOrg().then((res) => {
                    $scope.bankList = res.data.value.map((item) => ({
                        accountId: item.accountId,
                        bankText: `${item.bankAccount}|${item.bank}`,
                    }))
                })
            })
        })
        // 是否符合金钱，小数点前12位，后两位
        function isRuledMoney(argument) {
            // 企业信用度代码检测；
            const reg = /(^[1-9][0-9]{0,11}$)|(^[0]$)|(^[0]\.\d{0,2}$)|(^[1-9][0-9]{0,11}\.\d{0,2}$)/
            return reg.test(argument)
        }

        // 规则

        $scope.validateRules = {
            diskCode: [
                {
                    erromsg: '必填项，只允许数字，最多32位字符',
                    condition(value) {
                        // 规则
                        return !(value && value.length >= 0 && value.length <= 32)
                    },
                },
            ],
            diskName: [
                {
                    erromsg: '必填项，企业自定义名称，最多100位字符',
                    condition(value) {
                        // 规则
                        return !(value && value.length > 0 && value.length <= 100)
                    },
                },
            ],
            ukeyName: [
                {
                    erromsg: '必填项，企业自定义名称，最多100位字符',
                    condition(value) {
                        // 规则
                        return !(value && value.length > 0 && value.length <= 100)
                    },
                },
            ],
            ukeyCode: [
                {
                    erromsg: '必填项，最多4位字符',
                    condition(value) {
                        // 规则
                        return !(value && value.length > 0 && value.length <= 4)
                    },
                },
            ],
            diskNo: [
                {
                    erromsg: '必填项，硬件厂家出厂时的机器编号，12位字符',
                    condition(value) {
                        // 规则
                        return !(value && value.length == 12)
                    },
                },
            ],
            specialQuota: [
                {
                    erromsg: '必填项，只允许输入金额，小数点前12位，后两位',
                    condition(value) {
                        // 规则
                        return !isRuledMoney(value)
                    },
                },
            ],
            generalQuota: [
                {
                    erromsg: '必填项，只允许输入金额，小数点前12位，后两位',
                    condition(value) {
                        // 规则
                        return !isRuledMoney(value)
                    },
                },
            ],
            electronicQuota: [
                {
                    erromsg: '必填项，只允许输入金额，小数点前12位，后两位',
                    condition(value) {
                        // 规则
                        return !isRuledMoney(value)
                    },
                },
            ],
            eleSpecialQuota: [
                {
                    erromsg: '必填项，只允许输入金额，小数点前12位，后两位',
                    condition(value) {
                        // 规则
                        return !isRuledMoney(value)
                    },
                },
            ],
            volumeQuota: [
                {
                    erromsg: '必填项，只允许输入金额，小数点前12位，后两位',
                    condition(value) {
                        // 规则
                        return !isRuledMoney(value)
                    },
                },
            ],
            vehicleQuota: [
                {
                    erromsg: '必填项，只允许输入金额，小数点前12位，后两位',
                    condition(value) {
                        // 规则
                        return !isRuledMoney(value)
                    },
                },
            ],
            accountId: [
                {
                    erromsg: '必填项',
                    condition(value) {
                        // 规则
                        console.log(value)
                        return !(($scope.bankList.length == 0 && (value == '' || value == undefined)) || ($scope.bankList.length > 0 && (value != '' || value != undefined)))
                    },
                },
            ],
        }
        // 编辑
        $scope.submitTaxDiskForm0 = function (vmform) {
            if ($scope.taxDiskForm0.deviceType == 1) $scope.taxDiskForm0.diskCode = $scope.taxDiskForm0.diskNo
            const ret = formvalidateApi.run()
            if (ret) {
                if (!$scope.taxDiskForm0.accountId && $scope.taxDiskForm0.diskType != '5') return logger.logError('开户银行不能为空')
                let updateTaxDiskApi = 'post_updateTaxDisk'
                if ($scope.taxDiskForm0.deviceType == '3') {
                    updateTaxDiskApi = 'post_updateTax4Ukey'
                }
                httpRequest[updateTaxDiskApi]($scope.taxDiskForm0, '编辑成功').then((res) => {
                    $rootScope.$broadcast('userInfoChanged')
                    $state.go('system.basedata.ticketedPoint.list')
                })
            }
        }
        // 返回
        $scope.cancelTaxDiskForm0 = function () {
            $state.go('system.basedata.ticketedPoint.list')
            return false
        }
        $scope.openDefaultDrawerModel = function (confirmMsg) {
            $uibModal.open({
                templateUrl: 'defaultDrawerModel.html',
                controller: ['$scope', '$uibModalInstance', 'httpRequest', ($scope, $uibModalInstance, httpRequest) => {
                    $scope.statusList0 = [
                        {
                            id: '',
                            text: '全部',
                        },
                        {
                            id: 0,
                            text: '未启用',
                        },
                        {
                            id: 1,
                            text: '启用',
                        },
                    ]
                    const typecodeArrStr = '["drawer_active_status","drawer_channel_type"]'
                    httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
                        $scope.dictData = res.data.value
                    })
                    httpRequest.post_getActiveSucceedOrgList({}).then((res) => {
                        $scope.listData = res.data.value
                    })
                    $scope.clickRadio = function clickRadio(item) {
                        $scope.drawerList = item
                    }
                    $scope.ok = function ok() {
                        httpRequest.post_existUkeyCodeNewUkeyCode($scope.drawerList.taxAccountName).then((res) => {
                            $scope.drawerList.taxAccountName = res.data.value
                            $uibModalInstance.close($scope.drawerList)
                        })
                    }
                    $scope.cancel = function cancel() {
                        $uibModalInstance.dismiss()
                    }
                }],
                resolve: {
                    items1() {
                        return $scope.drawerList
                    },
                },
                openedClass: 'mod-modal mod-modal-hg',
                backdrop: 'static',
            })
            .result.then((result) => {
                if (result) {
                    $scope.taxDiskForm0.defaultDrawer = result.realName
                    $scope.taxDiskForm0.drawerId = result.drawerId
                    $scope.taxDiskForm0.ukeyCode = result.taxAccountName
                    $scope.taxDiskForm0.ukeyName = result.realName
                    $scope.taxDiskForm0.status = result.status
                    if(result.channelType){
                        $scope.taxDiskForm0.manageType = result.channelType
                    }
                    console.log($scope.taxDiskForm0)
                }
            })
        }
        // 解绑
        $scope.unbindUser  = function () {
            $scope.taxDiskForm0.defaultDrawer = ''
            $scope.taxDiskForm0.drawerId = ''
            $scope.taxDiskForm0.manageType = '8'
        }
    }
}
ticketedPointEditCtrl0.$inject = ['$rootScope', '$scope', 'httpRequest', '$state', 'formvalidateApi', 'logger', '$uibModal']
export default ticketedPointEditCtrl0



// WEBPACK FOOTER //
// ./src/app/system/basedata/ticketedPoint/ticketedPointEditCtrl0.js